import { AspectRatio } from '@mantine/core';
import { useSelector } from "react-redux";

/**
 * Renders a document viewer for a specific resource ID.
 *
 * @param {Object} props - The component props.
 * @param {string} props.resourceId - The ID of the resource to display.
 * @return {JSX.Element} The document viewer component.
 */

const GuestShowDoc = (props:any ) => {
    //const showdocs = useSelector((state: any) => state.user.guest_documents)
    const guest_DocumentOneTimeLink = useSelector((state: any) => state.user.guest_DocumentOneTimeLink)
    let docurl = "";
    if (guest_DocumentOneTimeLink !== null) {
      docurl = guest_DocumentOneTimeLink
    } 
    if (guest_DocumentOneTimeLink !== null) {
    return (
        <>
          <AspectRatio ratio={16 / 9} sx={{ maxWidth: 1920 }} mx="auto">
          <iframe
                src={docurl}
                title={"Testraum"}
                allow="camera;microphone;display-capture"
                allowFullScreen
                frameBorder= "0"
              />
          </AspectRatio>
        </>
    )
   } else {
    return (
      <>
        
      </>
    )
  }
};

export default GuestShowDoc;